module.exports = __webpack_public_path__ + "static/img/bg-pt.1bd32cb3.png";